import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { sendEmailVerification } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase.js";

export default function EmailVerification() {
  const navigate = useNavigate();

  const resendVerification = async () => {
    if (auth.currentUser) {
      await sendEmailVerification(auth.currentUser);
      // Show a message: "Verification email resent!"
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          width: "20rem",
          justifyContent: "center",
          alignItems: "center",
          overflowY: "hidden",
          overflowX: "hidden",
          gap: 1,
          alignSelf: "center",
          justifySelf: "center",
        }}
      >
        <Typography
          style={{
            textAlign: "center",
            marginTop: "2rem",
            color: "Gray",
          }}
          variant="h6"
          gutterBottom
        >
          A verification code has been sent to your email. Please check your
          inbox and junk folder.
        </Typography>
        <Button
          onClick={resendVerification}
          variant="contained" // solid color
          color="primary"
          size="large"
        >
          Resend
        </Button>
        <Button
          onClick={() => navigate("/signup")}
          variant="contained" // solid color
          color="primary"
          size="large"
        >
          Login Instead
        </Button>
      </Box>
    </Box>
  );
}
